// store/counter-provider.tsx
'use client'

import { createContext, useContext, useRef } from 'react'
import { useStore } from 'zustand'
import { createEVMiStore, EVMiStoreState } from './evmi-store'

type EVMiStore = ReturnType<typeof createEVMiStore>

const EVMiContext = createContext<EVMiStore | null>(null)

export const EVMiProvider = ({
  children,
  initialState,
}: {
  children: React.ReactNode
  initialState?: Partial<EVMiStoreState>
}) => {
  const storeRef = useRef<EVMiStore>(createEVMiStore(initialState))

  if (!storeRef.current) {
    storeRef.current = createEVMiStore(initialState)
  }

  return (
    <EVMiContext.Provider value={storeRef.current}>
      {children}
    </EVMiContext.Provider>
  )
}

export const useEVMiStore = <T,>(
  selector: (state: EVMiStoreState) => T
) => {
  const store = useContext(EVMiContext)
  if (!store) throw new Error('Missing CounterProvider')
  return useStore(store, selector)
}